import { useContext, useEffect, useState } from "react"
import swal from "sweetalert"
import { UserContext } from "../../../apps/_root"
import { with_comma } from "../../../util/comma"
import api from "../../../util/api"
import adLayoutImage from "../../../_asset/banner/ad.png"
import { PageModalContext } from "../../../apps/providers"
import { sexyVendor } from "../../../data/gameData_casino"

export default function SafeLayout() {
    const { User } = useContext(UserContext)
    
    const [delaySafe, setDelaySafe] = useState<boolean>(false)
    const [delayWallet, setDelayWallet] = useState<boolean>(false)
    
    const limit = 10000

    function setAmoutSafe(amount: number) {
        if (amount <= 0) {
            swal({ text: `최소 이동 금액 ${with_comma(limit)} 이상 입니다.`, icon: "error" })
            setDelaySafe(false)
            return false;
        }
        // --
        if (User.money < amount) {
            swal({ text: "현재 보유금이 부족합니다.", icon: "error" })
            setDelaySafe(false)
        } else {
            const data = { amount: amount }
            api(`/api/user/put_into_safe`, { method: "POST", headers: { "Content-Type": 'application/json' }, body: JSON.stringify(data) })
                .then(() => {
                    swal({ text: "금고로 이동 되었습니다.", icon: "success" }) 
                    setDelaySafe(false)
                })
                .catch((error: Response) => handleError(error))
        }
    }
    function setAmountWallet(amount: number) {
        if (amount <= 0) {
            swal({ text: `최소 이동 금액 ${with_comma(limit)} 이상 입니다.`, icon: "error" })
            setDelayWallet(false)
            return false;
        }
        // --
        if (User.safe_money < amount) {
            swal({ text: "금고 금액이 부족합니다.", icon: "error" })
            setDelayWallet(false)
        } else {
            const data = { amount: amount }
            api(`/api/user/take_out_safe`, { method: "POST", headers: { "Content-Type": 'application/json' }, body: JSON.stringify(data) })
                .then(() => {
                    swal({ text: "지갑으로 이동 되었습니다.", icon: "success" }) 
                    setDelayWallet(false)
                })
                .catch((error: Response) => handleError(error))
        }
    }
    async function handleError(error: Response) {
        const err = await error.json()
        if (typeof err == 'string') {
            swal({ text: err, icon: "error" })
        } else {
            swal({ text: "오류가 발생했습니다.", icon: "error" })
        }
    }

    return (
        <div className="safe-container">
            <p>금고 이동</p>
            <div className="warning">
                <p>- 현재 보유금으로 금고 머니 이동이 가능합니다.</p>
                <p>- 금고 머니이동 금액은 최소 {with_comma(limit)}원 부터 1만원 단위로 이동 하실 수 있습니다.</p>
            </div>

            <div className="safe-layout">
                <div className="to-safe">
                    <ToAmount type="safe" 
                              setAmountFunc={setAmoutSafe} 
                              delay={delaySafe}
                              setDelay={setDelaySafe} />
                </div>
                <div className="to-wallet">
                    <ToAmount type="wallet" 
                              setAmountFunc={setAmountWallet} 
                              delay={delayWallet}
                              setDelay={setDelayWallet} />
                </div>
            </div>
            <AdLayout />
        </div>
    )
}

function AdLayout(){
    const { UserAuthCheck } = useContext(UserContext)
    const { SetMenuType, SetVendor, SetPageName, SetPageModalShow } = useContext(PageModalContext)
    
    return (
        <div className="ad-layout" 
        onClick={e =>
            UserAuthCheck(() => {
                if(sexyVendor){
                    SetMenuType('vendor')
                    SetPageName(sexyVendor.name)
                    SetVendor(sexyVendor.vendor)
                    SetPageModalShow(true)
                }
            })
        }>
            <img src={adLayoutImage} alt="" />
        </div>
    )
}

type toMoneyTypes = "safe" | "wallet"
function ToAmount({ type, setAmountFunc, delay, setDelay }: { type: toMoneyTypes, setAmountFunc: Function, delay: boolean, setDelay: Function }) {
    const { User } = useContext(UserContext)
    const [amount, setAmount] = useState<number>(0)

    const btns: (number | string)[] = [10000, 50000, 100000, 500000, '전체', '초기화']

    function addAmount(num: number | string) {
        if (typeof num == 'number') {
            setAmount(amount + num)
        } else if (num == "전체") {
            if (type == "safe") {
                setAmount(User.money)
            } else if (type == "wallet") {
                setAmount(User.safe_money)
            }
        } else if (num == "초기화") {
            setAmount(0)
        }
    }

    return (
        <>
            <div className="safe-row">
                <div>
                    {type == "safe" && "내 보유머니"}
                    {type == "wallet" && "금고 보유머니"}
                </div>
                <div>
                    {type == "safe" && with_comma(User.money) + " 원"}
                    {type == "wallet" && with_comma(User.safe_money) + " 원"}
                </div>
            </div>
            <div className="safe-row">
                <div></div>
                <div>{with_comma(amount)} 원</div>
            </div>
            <div className="safe-row amount-btns">
                <ul>
                    {
                        btns.map((num, index) => (
                            <li key={index} onClick={e => addAmount(num)}>
                                {typeof num == "number" ? with_comma(num) : num}
                            </li>
                        ))
                    }
                </ul>
            </div>
            <div className="safe-row submit">
                <div className={`submit-btn ${delay ? "disabled" : ""}`} onClick={e => {
                    if (delay) {
                        swal({ text: "머니 이동 대기중 입니다.", icon: "warning" })
                    } else {
                        setDelay(true)
                        setAmountFunc(amount)
                    }
                }}>
                    {
                        delay
                            ? "대기중"
                            : <>
                                {type == "safe" && "머니 이동"}
                                {type == "wallet" && "머니 회수"}
                            </>
                    }
                </div>
            </div>
        </>
    )
}